import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';

import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {Observable} from 'rxjs/Observable';

import {AuthService} from '../core/auth.service';
import {EcvLanguageService} from '../core/ecv-language.service';
import {environment} from '../../environments/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {

  public currentLng: string;
  public languageToSwitch$: Observable<string>;
  public collapse = false;

  constructor(public authService: AuthService,
              private languageService: EcvLanguageService,
              private router: Router,
              private spinnerService: Ng4LoadingSpinnerService,
              @Inject(DOCUMENT) private document: any) {
  }

  ngOnInit() {
    this.currentLng = this.languageService.getLanguage();
    this.languageToSwitch$ = this.languageService.getLanguageToSwitch$();
  }

  onLogOut() {
    const isSpecialist = this.authService.isSpecialist();
    this.authService.logOut();
    if (isSpecialist && environment.production) {
      this.spinnerService.show();
      this.document.location.href = 'https://www.connectis.pl/cloud/login';
    } else {
      this.router.navigate(['/login']);
    }
  }

  toggleLanguageMenu() {
    this.languageService.toggleLanguage();
  }

  get currentUserEmail() {
    return localStorage.getItem('userFirstName');
  }

  checkIfUnionMode() {
    return document.getElementsByClassName('ecv-union').length !== 0;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/header/header.component.ts